// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"DocsMobile_checkbox__MH4CS","skeleton":"DocsMobile_skeleton__VNLhU","skeletonFlex":"DocsMobile_skeletonFlex__S_J79"};